"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _button = require("@creditas-lab/button");

const Container = _stylitas.styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;

  ${_styleUtilities.media.md`
    justify-content: space-around;
    padding: 40px;
  `}

  ${_styleUtilities.media.lg`
    justify-content: space-between;
  `}
`;
exports.Container = Container;
Container.Body = _stylitas.styled.div`
  padding-top: 20px;
  margin-bottom: 32px;

  ${_styleUtilities.media.lg`
    padding-top: 32px;
    display: flex;
    align-items: center;
  `}
`;
Container.Footer = _stylitas.styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & button {
    margin-bottom: 16px;

    ${_styleUtilities.media.md`
      margin-bottom: 24px;
      width: 180px;
    `};
  }
`;
const StyledButton = (0, _stylitas.styled)(_button.Button)`
  min-height: 60px;
`;
exports.Button = StyledButton;